if (typeof window.TextWithIconsMobile === 'undefined') {
class TextWithIconsMobile {
  constructor() {
    this.initMobileScroll();
  }

  initMobileScroll() {
    const containers = document.querySelectorAll('[data-mobile-scroll="true"]');
    
    containers.forEach(container => {
      const items = container.querySelectorAll('.text__with--icons-single--item');
      
      if (items.length > 1 && window.innerWidth <= 749) {
        this.addScrollIndicators(container, items.length);
        this.handleScrollEvents(container);
      }
    });
  }

  addScrollIndicators(container, itemCount) {
    // Create indicator container
    const indicatorContainer = document.createElement('div');
    indicatorContainer.className = 'text__with--icons-scroll-indicators';
    
    // Create dots
    for (let i = 0; i < itemCount; i++) {
      const dot = document.createElement('span');
      dot.className = 'scroll-indicator-dot';
      if (i === 0) dot.classList.add('active');
      indicatorContainer.appendChild(dot);
    }
    
    // Insert indicators after the container
    container.parentNode.insertBefore(indicatorContainer, container.nextSibling);
  }

  handleScrollEvents(container) {
    const indicators = container.parentNode.querySelector('.text__with--icons-scroll-indicators');
    if (!indicators) return;

    const dots = indicators.querySelectorAll('.scroll-indicator-dot');
    const items = container.querySelectorAll('.text__with--icons-single--item');

    container.addEventListener('scroll', () => {
      const scrollLeft = container.scrollLeft;
      const itemWidth = items[0].offsetWidth + 32; // item width + gap
      const activeIndex = Math.round(scrollLeft / itemWidth);

      // Update active dot
      dots.forEach((dot, index) => {
        dot.classList.toggle('active', index === activeIndex);
      });
    });

    // Add click handlers to dots
    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        const itemWidth = items[0].offsetWidth + 32;
        container.scrollTo({
          left: index * itemWidth,
          behavior: 'smooth'
        });
      });
    });
  }
}
window.TextWithIconsMobile = TextWithIconsMobile;
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new TextWithIconsMobile();
});

// Reinitialize on window resize
window.addEventListener('resize', () => {
  // Remove existing indicators
  document.querySelectorAll('.text__with--icons-scroll-indicators').forEach(el => el.remove());
  
  // Reinitialize if on mobile
  if (window.innerWidth <= 749) {
    new TextWithIconsMobile();
  }
});